import React from "react";
import { Form } from "react-bootstrap";



function NumericEditor(props) {

  function handleChange(event) {
    props.onChange( event.target.value );
  }


  return (
    <Form.Control type="text" value={props.value} onChange={handleChange} />
  );
}


export default NumericEditor;
